import SettingsPopup from './SettingsPopup';
export default SettingsPopup;